"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.Virus = exports.Thermometer = exports.TestTubeMinimalistic = exports.TestTube = exports.Syringe = exports.Stethoscope = exports.Pulse2 = exports.Pulse = exports.Pills3 = exports.Pills2 = exports.Pills = exports.Pill = exports.MedicalKit = exports.JarOfPills2 = exports.JarOfPills = exports.HeartPulse2 = exports.HeartPulse = exports.Health = exports.DropperMinimalistic2 = exports.DropperMinimalistic = exports.Dropper3 = exports.Dropper2 = exports.Dropper = exports.DNA = exports.Bones = exports.BoneCrack = exports.BoneBroken = exports.Bone = exports.BenzeneRing = exports.Bacteria = exports.AdhesivePlaster2 = exports.AdhesivePlaster = void 0;
var AdhesivePlaster_1 = require("./AdhesivePlaster");
__createBinding(exports, AdhesivePlaster_1, "default", "AdhesivePlaster");
var AdhesivePlaster2_1 = require("./AdhesivePlaster2");
__createBinding(exports, AdhesivePlaster2_1, "default", "AdhesivePlaster2");
var Bacteria_1 = require("./Bacteria");
__createBinding(exports, Bacteria_1, "default", "Bacteria");
var BenzeneRing_1 = require("./BenzeneRing");
__createBinding(exports, BenzeneRing_1, "default", "BenzeneRing");
var Bone_1 = require("./Bone");
__createBinding(exports, Bone_1, "default", "Bone");
var BoneBroken_1 = require("./BoneBroken");
__createBinding(exports, BoneBroken_1, "default", "BoneBroken");
var BoneCrack_1 = require("./BoneCrack");
__createBinding(exports, BoneCrack_1, "default", "BoneCrack");
var Bones_1 = require("./Bones");
__createBinding(exports, Bones_1, "default", "Bones");
var DNA_1 = require("./DNA");
__createBinding(exports, DNA_1, "default", "DNA");
var Dropper_1 = require("./Dropper");
__createBinding(exports, Dropper_1, "default", "Dropper");
var Dropper2_1 = require("./Dropper2");
__createBinding(exports, Dropper2_1, "default", "Dropper2");
var Dropper3_1 = require("./Dropper3");
__createBinding(exports, Dropper3_1, "default", "Dropper3");
var DropperMinimalistic_1 = require("./DropperMinimalistic");
__createBinding(exports, DropperMinimalistic_1, "default", "DropperMinimalistic");
var DropperMinimalistic2_1 = require("./DropperMinimalistic2");
__createBinding(exports, DropperMinimalistic2_1, "default", "DropperMinimalistic2");
var Health_1 = require("./Health");
__createBinding(exports, Health_1, "default", "Health");
var HeartPulse_1 = require("./HeartPulse");
__createBinding(exports, HeartPulse_1, "default", "HeartPulse");
var HeartPulse2_1 = require("./HeartPulse2");
__createBinding(exports, HeartPulse2_1, "default", "HeartPulse2");
var JarOfPills_1 = require("./JarOfPills");
__createBinding(exports, JarOfPills_1, "default", "JarOfPills");
var JarOfPills2_1 = require("./JarOfPills2");
__createBinding(exports, JarOfPills2_1, "default", "JarOfPills2");
var MedicalKit_1 = require("./MedicalKit");
__createBinding(exports, MedicalKit_1, "default", "MedicalKit");
var Pill_1 = require("./Pill");
__createBinding(exports, Pill_1, "default", "Pill");
var Pills_1 = require("./Pills");
__createBinding(exports, Pills_1, "default", "Pills");
var Pills2_1 = require("./Pills2");
__createBinding(exports, Pills2_1, "default", "Pills2");
var Pills3_1 = require("./Pills3");
__createBinding(exports, Pills3_1, "default", "Pills3");
var Pulse_1 = require("./Pulse");
__createBinding(exports, Pulse_1, "default", "Pulse");
var Pulse2_1 = require("./Pulse2");
__createBinding(exports, Pulse2_1, "default", "Pulse2");
var Stethoscope_1 = require("./Stethoscope");
__createBinding(exports, Stethoscope_1, "default", "Stethoscope");
var Syringe_1 = require("./Syringe");
__createBinding(exports, Syringe_1, "default", "Syringe");
var TestTube_1 = require("./TestTube");
__createBinding(exports, TestTube_1, "default", "TestTube");
var TestTubeMinimalistic_1 = require("./TestTubeMinimalistic");
__createBinding(exports, TestTubeMinimalistic_1, "default", "TestTubeMinimalistic");
var Thermometer_1 = require("./Thermometer");
__createBinding(exports, Thermometer_1, "default", "Thermometer");
var Virus_1 = require("./Virus");
__createBinding(exports, Virus_1, "default", "Virus");
